import React from 'react';
import { EXTERNAL_APPS } from '../types/AppsExternal';
import { IconTruck } from '../images/icons/IconTruck';
import { Iconb2b } from '../images/icons/Iconb2b';
import { IconQlikView } from '../images/icons/IconQlikView';
import { IconEventViewer } from '../images/icons/IconEventViewer';
export var EXTERNAL_SITES = [
    { label: EXTERNAL_APPS.MICHELIN_TRUCK_TIRE, to: 'https://www.michelintruck.com/', icon: React.createElement(IconTruck, null) },
    { label: EXTERNAL_APPS.MICHELINB2B, to: 'https://www.michelinb2b.com/', icon: React.createElement(Iconb2b, null) },
    {
        label: EXTERNAL_APPS.PO_EVENT_VIEWER,
        to: 'https://event-viewer.oncall-prod.misp-solutions.com/',
        icon: React.createElement(IconEventViewer, null),
    },
    { label: EXTERNAL_APPS.QLIKVIEW, to: 'https://reports.mrt.michelinb2b.com/', icon: React.createElement(IconQlikView, null) },
];
export var EXTERNAL_SITES_CANADA = [
    { label: EXTERNAL_APPS.MICHELIN_TRUCK_TIRE, to: 'https://www.michelintruck.com/fr_CA/', icon: React.createElement(IconTruck, null) },
    { label: EXTERNAL_APPS.MICHELINB2B, to: 'https://www.michelinb2b.com/', icon: React.createElement(Iconb2b, null) },
    {
        label: EXTERNAL_APPS.PO_EVENT_VIEWER,
        to: 'https://event-viewer.oncall-prod.misp-solutions.com/',
        icon: React.createElement(IconEventViewer, null),
    },
    { label: EXTERNAL_APPS.QLIKVIEW, to: 'https://reports.mrt.michelinb2b.com/', icon: React.createElement(IconQlikView, null) },
];
//# sourceMappingURL=externalSitesArray.js.map